import {
  AI_BUTTON_ICON_LINEAR_GRADIENT_LAYOUT,
  AI_BUTTON_ICON_LINEAR_GRADIENT_STOPS,
} from '../AIButton.constants'
import { isAIButtonIconGradientSvgPlacementOffscreen } from '../AIButton.utils'

import * as styles from './AIButtonIconGradientDef.module.css'

function AIButtonIconGradientDef({ gradientId, placement }) {
  const placementClassName = isAIButtonIconGradientSvgPlacementOffscreen(
    placement
  )
    ? styles.offscreen
    : styles.embedded

  return (
    <svg
      aria-hidden
      className={placementClassName}
      focusable='false'
      height={0}
      width={0}
    >
      <defs>
        <linearGradient
          {...AI_BUTTON_ICON_LINEAR_GRADIENT_LAYOUT}
          id={gradientId}
        >
          {AI_BUTTON_ICON_LINEAR_GRADIENT_STOPS.map(({ offset, stopColor }) => (
            <stop key={offset} offset={offset} stopColor={stopColor} />
          ))}
        </linearGradient>
      </defs>
    </svg>
  )
}

export default AIButtonIconGradientDef
